// TODO(Maros): Will probably be pulled from API
export const GOAL_REAL_YIELD = 0.04;

export const ALLOCATION_MIN = 5;
export const ALLOCATION_MAX = 100;
export const ALLOCATION_STEP = 5;

export const LOAN_RATE_MIN = 2;
export const LOAN_RATE_MAX = 8;
export const LOAN_RATE_STEP = 0.1;
export const LOAN_TERM_STEP = 1;

export const WHAT_IF_EXTRA_PRESETS = [500, 1_000, 2_000, 5_000];
export const WHAT_IF_EXTRA_DEFAULT = 1_000;
export const WHAT_IF_EXTRA_MAX = 10_000;
export const WHAT_IF_EXTRA_STEP = 100;
export const WHAT_IF_PROGRESS_MIN = 5;
export const WHAT_IF_PROGRESS_MAX = 95;

export const SAVINGS_DELAY_MONTHS = 12;
export const SAVINGS_DELAY_MIN_MONTHS = 6;
